// extracted by mini-css-extract-plugin
export default {"AfterPayment":"AfterPayment_AfterPayment__ALmeG","shadow":"AfterPayment_shadow__Hcj21","shadow2":"AfterPayment_shadow2__FvtKR"};